import Timeline from '@mui/lab/Timeline';
import { Container } from './styles';
import { middleLeftAnimationProps, middleRightAnimationProps } from '../../../functionallity/animationProps';
import CustomTimelineElement from './CustomTimeLineElement/CustomTimeLineElement';
import farmOnDay from "../../../../assets/images/History/TimeLine/farmOnDay.png"
import farm from "../../../../assets/images/History/TimeLine/farm.png"
import AngryMob from "../../../../assets/images/History/TimeLine/AngryMob.png"
import ceremony from "../../../../assets/images/History/TimeLine/ceremony.png"

const CustomTimelineItemComponentProps = [
    {
        imagePath: farmOnDay,
        heading: "Das Schicksal des Schweinezüchters Karl",
        paragraph: "Auf der Höhe von Schramberg, zwischen den Dörfern Sulgen und Sulgau, lebte im Jahr 1611 der Schweinezüchter Karl. Bekannt und geschätzt versorgte er das Umland mit Schweinefleisch, eine Tradition, die seit Generationen in seiner Familie bestand. Karl war beliebt in Sulgen und auch in Sulgau wurde seine Arbeit geschätzt. Doch sein Leben sollte sich in einer kalten, diesigen Nacht auf dramatische Weise ändern.",
        paragraphAnimation: middleRightAnimationProps,
        imageAnimation: middleLeftAnimationProps
    },
    {
        imagePath: farm,
        heading: "Die Wildschweine des Eckenwalds",
        paragraph: "Am Rand des Eckenhofs grenzte der unheimliche Eckenwald, ein Gebiet, das wegen seiner aggressiven Wildschweine gefürchtet war. Eines Nachts drangen die Wildschweine auf Karls Hof ein, fraßen das Futter der Zuchtschweine und suhlten sich in den Trögen. Ohne es zu wissen, fütterte Karl am nächsten Morgen seine Schweine in diesen verseuchten Trögen – was fatale Folgen hatte.",
        paragraphAnimation: middleLeftAnimationProps,
        imageAnimation: middleRightAnimationProps
    },
    {
        imagePath: AngryMob,
        heading: "Der Verrat und Karls Tod im Moor",
        paragraph: "Nach und nach erkrankten nicht nur Karls Schweine, sondern auch die Menschen, die das Fleisch aßen. Die Dorfbewohner beschuldigten Karl, das Fleisch absichtlich verseucht zu haben. Niemand glaubte mehr an seine Unschuld, und in Panik entschied die Gemeinschaft, Karl im Moor zu ertränken, um die vermeintliche Seuche zu stoppen. So fand Karl einen grausamen Tod im Moor – zu Unrecht beschuldigt und ohne Verteidigung.",
        paragraphAnimation: middleRightAnimationProps,
        imageAnimation: middleLeftAnimationProps
    },
    {
        imagePath: ceremony,
        heading: "Die Rückkehr des Moorenkarle und die Eckenmoorhexen",
        paragraph: "Doch die Dorfbewohner hatten sich zu früh in Sicherheit gewiegt. Das Moor begann zu brodeln und Karl erhob sich aus den Tiefen, gefolgt von Hexen aus dem Eckenwald, um sich an denen zu rächen, die ihm Unrecht getan hatten. Diese unheimliche Legende lebte über Jahrhunderte weiter, und 400 Jahre später, im Jahr 2011, rief der „Moorenkarle“ erneut seine Eckenmoorhexen zusammen, um an der Fasnet gemeinsam ihr unheimliches Erbe weiterzutragen.",
        paragraphAnimation: middleLeftAnimationProps,
        imageAnimation: middleRightAnimationProps
    }
]


const CustomTimeLine = () => {
    return (
        <Container>
            <Timeline position="alternate">
                {CustomTimelineItemComponentProps.map((item, index) => {
                    return (
                        <CustomTimelineElement
                            key={index}
                            imagePath={item.imagePath}
                            heading={item.heading}
                            paragraph={item.paragraph}
                            imageAnimation={item.imageAnimation}
                            paragraphAnimation={item.paragraphAnimation}
                            contentLeft={index % 2 === 0}
                        />
                    );
                })}
            </Timeline>
        </Container>
    );
}

export default CustomTimeLine;